import styled from 'styled-components'

export const BannerWrapper = styled.div`
  padding: 16px 20px 16px 16px;
  margin: 20px 0;
  border-radius: 10px;
  position: relative;
  display: flex;
`

export const BannerContent = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  gap: 16px;
  z-index: 1;
`

export const BannerBackgroundImg = styled.img`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
`

export const BannerDescription = styled.div`
  font-size: 14px;
  color: #4c4c4c;
`
